import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHelp = () => {
  return (
    <g>
      <path d="m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.9591 7.9591 0 0 0 -7.95-7.95zm.75 12.5654a.75.75 0 0 1 -1.5 0v-.6a.75.75 0 0 1 1.5 0zm.7685-4.3047a1.5452 1.5452 0 0 0 -.7685 1.3321.75.75 0 1 1 -1.5 0 3.05 3.05 0 0 1 1.5171-2.63 1.5379 1.5379 0 1 0 -2.3049-1.3339.75.75 0 0 1 -1.5 0 3.0376 3.0376 0 1 1 4.5561 2.6319z" />
    </g>
  );
};

export default withIcon(IconHelp);
